import axios from "axios";
import { getAuthHeader } from "../../utils/authHeader";
import { AppConfigItem } from "./types";

const APP_CONFIG_URL = `${process.env.REACT_APP_BACKEND_URL}/app-config`;

export async function getAppConfigs(
    group?: string
): Promise<AppConfigItem[]> {
    try {
        const headers = await getAuthHeader();

        const response = await axios.get<AppConfigItem[]>(APP_CONFIG_URL, {
            headers,
            params: group ? { group } : undefined,
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching app config:", error);
        throw new Error("Error fetching app config");
    }
}

export async function updateAppConfig(
    key: string,
    value: unknown
): Promise<AppConfigItem> {
    try {
        const headers = await getAuthHeader();

        const response = await axios.put<AppConfigItem>(
            `${APP_CONFIG_URL}/${encodeURIComponent(key)}`,
            { value },
            { headers }
        );

        return response.data;
    } catch (error) {
        console.error("Error updating app config:", error);
        // Rethrow the original AxiosError so the caller can surface the backend's specific
        // validation message (e.g. "Max retries must be at most 10.").
        throw error;
    }
}

export async function resetAppConfig(key: string): Promise<AppConfigItem> {
    try {
        const headers = await getAuthHeader();

        const response = await axios.post<AppConfigItem>(
            `${APP_CONFIG_URL}/${encodeURIComponent(key)}/reset`,
            {},
            { headers }
        );

        return response.data;
    } catch (error) {
        console.error("Error resetting app config:", error);
        // Rethrow the original AxiosError so the caller can surface the backend's specific
        // validation message instead of a generic fallback.
        throw error;
    }
}
